<template>
  <div class="flex justify-between">
      <div class="title">
      {{ title }}
      </div>
      <div class="title-right">
          <slot name="select"></slot>
          <div class="more" @click.prevent="goDashboard" v-if="clickable">
            {{ $t('client_home.more') }}
          </div>
      </div>
  </div>
</template>
<script>

export default {
  name: 'CardTitle',
  props: {
      title: { type: String, default: '' },
      clickable: { type: Boolean, default: true },
      toDashboard: {
        type: Function,
        default: () => {
        }
      },
  },
  computed: {
  },
  methods:{
    goDashboard(){
      this.$emit('toDashboard')
    }
    
  }
}
</script>

<style scoped>
.title {
    font-size: 18px;
    color: #333333;
    height: 36px;
    line-height: 36px;
    font-weight: bolder;
}
.title-right{
  display: flex;
  align-items: center;
}
.more{
  background: #f3f6ff;
  color:#1e49e2;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  padding: 0 10px;
  text-align: center;
  font-weight: bold;
  height:32px;
  line-height:32px
}
.more:hover{
  text-decoration: underline;
}
</style>

